<template>
  <SubHeading :home="home" :tabs="tabs" :shorts="true" :currTab="currTab" color="cyan darken-3"
    @active="handleActive" />

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->

   <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Contract Home</small></span>
      </div>
    </div>
  </nav>

  <!-- View Marker -->
  <div id="view"></div>

    <div class="container">
  <LoadingDiv v-if="!isReady" />

  <template v-else>
    <div class="grey-bg-custom">
      <div class="container">
        <div class="row">
          <div class="col s12">

            <div class="section">
              <h5 class="header">
                All User <b>Accounts </b>
                <span @click="handleSwitch()">
                  <span class="btn-floating btn-large waves-effect waves-light" :class="{ teal: !next, red: next }"><i
                      class="material-icons" title="Add User (New)">{{
                        next ? "cancel" : "add"
                      }}</i></span>
                </span>
              </h5>
            </div>

            <template v-if="!next">
              <!-- New User Created! -->
             <div class="card" v-if="newUser">
                <div class="card-content teal lighten-5">
                  <div class="row">
                    <div class="col s2">
                      <img :src="newUser.profile_img" width="96" class="circle responsive-img"
                        v-if="newUser.profile_img" />
                      <img :src="`https://ui-avatars.com/api/?name=${newUser?.name}&background=a0a0a0&size=128`"
                        width="96" class="circle responsive-img" v-else />
                    </div>
                    <div class="col s8">

                      <b>{{ newUser.name }}</b>

                      <p v-if="newUser.designation">
                        <span class="chip teal lighten-4">{{ newUser.designation }}</span>
                      </p>

                      <template v-if="newUser.status !== 'd'">
                        <p>
                          <span class="chip grey darken-1 white-text" v-for="scheme in newUser.schemes"
                            :key="scheme.id">{{
                              allSchemes?.find(x => x.id === scheme)?.name}} scheme</span>
                          <br />
                        </p>

                        <p>
                          <span class="chip" v-for="module in newUser.modules" :key="module.id">{{ module }}
                            module</span>
                          <br /><br />
                        </p>
                      </template>

                      <p>
                        Department: {{ newUser.department }}
                      </p>

                      <div class="divider"></div>

                      <p>
                        Username: {{ newUser.email }}
                        <br /> Reset Password:
                        <span class="chip yellow lighten-4 text-black">
                          <b>{{newPasses.find(x => x.id ===
                            newUser.id)?.password
                          }}</b>
                        </span>
                      </p>

                      <div class="divider"></div>

                      <p>
                        Authority Level: <em>{{ newUser.level }}</em>/5
                      </p>

                      <div class="divider"></div>

                      <p>
                        Account Status:
                        <span class="green-text pointable" title="User account is active"
                          v-if="newUser.status === 'a'"><i class="tiny material-icons">check_circle</i> Active</span>
                        <span class="yellow-text text-darken-3 pointable" title="User account is pending"
                          v-if="newUser.status === 'p'"><i class="tiny material-icons">watch_later</i> Awaiting
                          Login</span>
                        <span class="orange-text pointable" title="User account is deactivated"
                          v-if="newUser.status === 'd'"><i class="tiny material-icons">lock</i> Deactivated</span>
                      </p>
                    </div>
                    <div class="col s2">
                      <LoadingSmallDiv v-if="isLoading === newUser.id" />
                      <template v-else>
                        <div class="right" v-if="newUser.status !== 'd'">
                          <a class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2"><i
                              class="material-icons" title="edit User" @click="handleEdit(newUser)">edit</i></a>
                          <br />
                        </div>
                        <div class="right">
                          <a class="btn-floating btn-medium waves-effect waves-light" :class="{
                            'red lighten-2': newUser.status == 'a' || newUser.status == 'p',
                            'green lighten-2': newUser.status == 'd',
                          }"><i class="material-icons" :title="newUser.status == 'a' || newUser.status == 'p'
                            ? 'suspend User'
                            : 'activate User'
                            " @click="handleStatus(newUser)">{{
                            newUser.status == "a" || newUser.status == 'p'
                              ? "pause_circle_outline"
                              : "play_circle_filled"
                              }}</i></a>
                          <br />
                        </div>
                        <div class="right" v-if="newUser.status !== 'd'">
                          <a class="btn-floating btn-medium waves-effect waves-light teal lighten-2"><i
                              class="material-icons" title="reset User" @click="handleReset(newUser)">sync</i></a>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Selected -->
              <div class="card-panel" v-for="(user, id) in users" :key="user.id"
                :class="{ 'red lighten-5': user.status == 'd', 'grey lighten-5': user.status == 'p' }">
                <div class="row">
                  <div class="col s2">
                    <img :src="user.profile_img" width="96" class="circle responsive-img" v-if="user.profile_img" />
                    <img :src="`https://ui-avatars.com/api/?name=${user?.name}&background=a0a0a0&size=128`" width="96"
                      class="circle responsive-img" v-else />
                  </div>
                  <div class="col s8">

                    <b>{{ user.name }}</b>

                    <p v-if="user.designation">
                      <span class="chip teal lighten-4">{{ user.designation }}</span>
                    </p>

                    <template v-if="user.status !== 'd'">
                      <p>
                        <span class="chip grey darken-1 white-text" v-for="scheme in user.schemes" :key="scheme.id">{{
                          allSchemes?.find(x => x.id === scheme)?.name}} scheme</span>
                        <br />
                      </p>

                      <p>
                        <span class="chip" v-for="module in user.modules" :key="module.id">{{ module }} module</span>
                        <br /><br />
                      </p>
                    </template>

                    <p>
                      Department: {{ user.department }}
                    </p>

                    <div class="divider"></div>

                    <p>
                      Username: {{ user.email }}
                      <span v-if="newPasses.find(x => x.id === user.id)"><br /> Reset Password: <span
                          class="chip yellow lighten-4 text-black"> <b>{{newPasses.find(x => x.id ===
                            user.id)?.password
                            }}</b></span></span>
                    </p>

                    <div class="divider"></div>

                    <p>
                      Authority Level: <em>{{ user.level }}</em>/5
                    </p>

                    <div class="divider"></div>

                    <p>
                      Account Status:
                      <span class="green-text pointable" title="User account is active" v-if="user.status === 'a'"><i
                          class="tiny material-icons">check_circle</i> Active</span>
                      <span class="yellow-text text-darken-3 pointable" title="User account is pending"
                        v-if="user.status === 'p'"><i class="tiny material-icons">watch_later</i> Awaiting
                        Login</span>
                      <span class="orange-text pointable" title="User account is deactivated"
                        v-if="user.status === 'd'"><i class="tiny material-icons">lock</i> Deactivated</span>
                    </p>
                  </div>
                  <div class="col s2">
                    <LoadingSmallDiv v-if="isLoading === user.id" />
                    <template v-else>
                      <div class="right" v-if="user.status !== 'd'">
                        <a class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2"><i
                            class="material-icons" title="edit User" @click="handleEdit(user)">edit</i></a>
                        <br />
                      </div>
                      <div class="right">
                        <a class="btn-floating btn-medium waves-effect waves-light" :class="{
                          'red lighten-2': user.status == 'a' || user.status == 'p',
                          'green lighten-2': user.status == 'd',
                        }"><i class="material-icons" :title="user.status == 'a' || user.status == 'p'
                        ? 'suspend User'
                        : 'activate User'
                        " @click="handleStatus(user)">{{
                            user.status == "a" || user.status == 'p'
                              ? "pause_circle_outline"
                              : "play_circle_filled"
                          }}</i></a>
                        <br />
                      </div>
                      <div class="right" v-if="user.status !== 'd'">
                        <a class="btn-floating btn-medium waves-effect waves-light teal lighten-2"><i
                            class="material-icons" title="reset User" @click="handleReset(user)">sync</i></a>
                      </div>
                    </template>
                  </div>
                  <div class="col s12">
                    <span class="chip">{{
                      id + 1
                    }}/{{ users.length }}</span>
                  </div>
                </div>


              </div>

              <!-- Empty -->
              <div v-if="!users.length">
                <span class="chip">No Active Users!</span>
              </div>
            </template>

            <template v-else>
              <div class="section">
                <div class="card grey lighten-4">
                  <!-- Heading -->
                  <div class="card-content">
                    <span class="card-title teal-text">
                      {{ userID ? 'Update User' : 'New User' }} 
                      <!-- <i class="material-icons right"
                        v-if="plans.length">check_circle</i> -->
                    </span>
                  </div>

                  <!-- Section 1 -->
                  <!-- Name -->
                  <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text pointable" title="required section"><i
                            class="tiny material-icons orange-text">star</i>User <em>Login</em> Details</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input type="text" id="userName" v-model="userName" required />
                          <label :class="{ 'active': userID }" for="userName">Staff Name</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Email -->
                  <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input type="text" id="userEmail" v-model="userEmail" required />
                          <label :class="{ 'active': userID }" for="userEmail">Login Email Address</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Designation -->
                  <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input type="text" id="userDesignation" v-model="userDesignation" required />
                          <label :class="{ 'active': userID }" for="userDesignation">Staff Designation</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Section 2 -->
                  <!-- Department -->
                  <div class="card-panel teal-text">
                    <!-- <div class="row">
                      <div class="col s12">
                        <span class="black-text pointable" title="optional">User <em>Company</em> Details</span>
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input type="text" id="userDepartment" v-model="userDepartment" />
                          <label :class="{ 'active': userID }" for="userDepartment">Staff Department</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Staff ID -->
                  <!-- <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input type="text" id="userStaffID" v-model="userStaffID" />
                          <label :class="{ 'active': userID }" for="userStaffID">Company Staff ID</label>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- Official Line -->
                  <!-- <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input type="text" id="userOfficialLine" v-model="userOfficialLine" />
                          <label :class="{ 'active': userID }" for="userOfficialLine">Staff Official Line</label>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- Section 3 -->
                  <!-- Level -->
                  <!-- <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text pointable" title="required section"><i
                            class="tiny material-icons orange-text">star</i>User <em>Authority</em></span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input-field col s12">
                        <select id="userLevel" v-model="userLevel" required>
                          <option value="" disabled selected>Choose your option</option>
                          <option value="1">Intern</option>
                          <option value="3">Staff</option>
                          <option value="5">Manager</option>
                        </select>
                        <label for="userLevel">User Authority Level</label>
                      </div>

                    </div>
                  </div> -->

                  <!-- Section 4 -->
                  <!-- Level -->
                  <!-- <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text pointable" title="required section"><i
                            class="tiny material-icons orange-text">star</i>User <em>Scheme(s)</em></span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12">
                        <label v-for="scheme in allSchemes" :key="scheme.id">
                          <input type="checkbox" class="filled-in" id="userSchemes" :value="scheme.id"
                            v-model="userSchemes" />
                          <span class="grey-text">{{ scheme.name }}</span>
                          <br />
                        </label>
                      </div>


                    </div>
                  </div> -->

                  <!-- Section 5 -->
                  <!-- Level -->
                  <!-- <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text pointable" title="required section"><i
                            class="tiny material-icons orange-text">star</i>User <em>Module(s)</em></span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12">
                        <label v-for="module in allModules" :key="module.id">
                          <input type="checkbox" class="filled-in" id="userModules" :value="module.to"
                            v-model="userModules" />
                          <span class="grey-text text-darken-1">{{ module.title }}</span> <span>({{ module.description
                          }})</span>
                          <br />
                        </label>
                      </div>


                    </div>
                  </div> -->

                </div>
              </div>

              <div class="section center">
                <p>
                  <a class="waves-effect waves-light btn-large grey" :class="{
                    disabled: isSubmitting,
                  }" @click="handleBack">
                    <i class="material-icons left">chevron_left</i>Back
                  </a>
                  <button class="waves-effect waves-light btn-large black" :class="{
                    disabled: isSubmitting,
                  }" @click="handleAdd">
                    <i class="material-icons right">chevron_right</i>
                    {{ isSubmitting ? "Sending..." : "Submit" }}
                  </button>
                </p>
              </div>
            </template>

          </div>
        </div>
      </div>

      <p>
        <br />
        <br />
      </p>

    </div>
  </template>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUpdated } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import getItems from "@/composables/getItems";
import postItem from "@/composables/postItem";
import putItem from "@/composables/putItem";
import { addModules } from "@/composables/cache/modules";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import LoadingSmallDiv from "@/components/LoadingSmallDiv.vue";
import M from "materialize-css";

export default {
  name: "ProfileComponent",
  components: { SubHeading, LoadingDiv, LoadingSmallDiv },
  setup() {
    const response = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const allSchemes = ref([]);
    const allModules = ref([]);
    const newPasses = ref([]);
    const isReady = ref(false);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const error = ref(null);
    const userID = ref(null);
    const userStatus = ref(null);
    const userName = ref(null);
    const userDesignation = ref(null);
    const userEmail = ref(null);
    const userDepartment = ref(null);
    const userStaffID = ref(null);
    const userOfficialLine = ref(null);
    const userLevel = ref(3); // staff default
    const userSchemes = ref([]);
    const userModules = ref([]);
    const newUser = ref(null);
    const next = ref(false);

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // client ID
    const clientId = store.state?.user?.account?.id;

    // start
    onMounted(() => {
      // page name
      document.title = "Profiles | EasyHMO";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Profiles", title: "Home", icon: null, url: "profiles", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Home"));
      // set home
      home.value = tabs.value.find(x => x.title.includes("Home"));
    });

    // select dropdown
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // select dropdown
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });


    // start
    onMounted(() => {
      // get items
      getUsers();
    });

    // get users
    const getUsers = (newUserId) => {
      // loasder on
      isReady.value = false;
      // start
      (async () => {
        const { res, err } = await getItems(`authority/user/client/${clientId}`);

        if (res.value) {
          response.value = res.value.data;
          allSchemes.value = res.value.schemes.filter(x => x.type === "p"); // private schemes only
          allModules.value = addModules().filter(x => x.type === "client" && x.to !== "profiles"); // keeping the same energy
          newUser.value = newUserId ? res.value.data.find(x => x.id === newUserId) : null; // clear new user on reload
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
        next.value = false;
      })();
    }

    // clear user
    const clearUser = () => {
      // clear all  
      userID.value = null;
      userStatus.value = null;
      userName.value = null;
      userDesignation.value = null;
      userEmail.value = null;
      userDepartment.value = null;
      userStaffID.value = null;
      userOfficialLine.value = null;
      userLevel.value = null;
      userSchemes.value = [];
      userModules.value = [];
    }

    // set user
    const setUser = (val) => {
      // set all  
      userID.value = val.id;
      userStatus.value = val.status;
      userName.value = val.name;
      userDesignation.value = val.designation;
      userEmail.value = val.email;
      userDepartment.value = val.department;
      userStaffID.value = val.staff_id;
      userOfficialLine.value = val.official_line;
      userLevel.value = val.level;
      userSchemes.value = val?.schemes?.length ? val.schemes : [];
      userModules.value = val?.modules?.length ? val.modules : [];
    }

    // edit User
    const handleEdit = (val) => {
      if (val.status !== 'd') {
        setUser(val);
        next.value = true;
      } else {
        // get all
        getUsers();
      }
    };

    // edit status
    const handleStatus = async (val) => {

      // start
      isLoading.value = val.id;

      // new
      let newStatus = null;

      // new status
      if (val.status == "a" || val.status == "p") {
        newStatus = "d"; // deactivate account
      } else if (val.status == "d") {
        newStatus = "p"; // make pending
      }

      // set new password (all the time)
      let newPass = Array(7).fill().map(() => String.fromCharCode(Math.floor(Math.random() * 26) + 97)).join('');

      // update
      let newVal = {
        status: newStatus,
        password: newPass,
      };

      // post item
      const { res, err } = await putItem("authority/client/update/vanilla", val.id, newVal);

      if (res.value) {
        // keep new password
        if (res.value.data.status !== "d") {
          // filter old passes out
          newPasses.value = newPasses.value.filter(x => x.id !== res.value.data.id);
          // keep password
          newPasses.value.push({ id: res.value.data.id, password: newPass });
        }
        // clear User
        clearUser();
        // reload users
        getUsers(res.value.data.id);
      } else {
        error.value = err.value;
      }

      // end
      isLoading.value = false;
    };

    // edit User status
    const handleReset = async (val) => {

      // start
      isLoading.value = val.id;

      if (val.status !== 'd') {

        // new
        let newStatus = "p";
        // set new password (all the time)
        let newPass = Array(7).fill().map(() => String.fromCharCode(Math.floor(Math.random() * 26) + 97)).join('');

        // update
        let newVal = {
          status: newStatus,
          password: newPass,
        };

        // post item
        const { res, err } = await putItem("authority/client/update/vanilla", val.id, newVal);

        if (res.value) {
          // filter old passes out
          newPasses.value = newPasses.value.filter(x => x.id !== res.value.data.id);
          // keep new password
          newPasses.value.push({ id: res.value.data.id, password: newPass });
          // clear User
          clearUser();
          // reload users
          getUsers(res.value.data.id);
        } else {
          error.value = err.value;
        }

      } else {
        // get all
        getUsers();
      }

      // end
      isLoading.value = false;
    };

    // handle update complete
    const handleUpdateComplete = (val) => {
      console.log(val);
    };

    const handleBack = () => {
      // restart
      next.value = false;
      // clear user
      clearUser();
    };

    const handleSwitch = () => {
     if (next.value) {
      // switch to main view
      next.value = false;
      // safety rule
      clearUser();
     } else {
      // switch to add/edit
      next.value = true;
     }
    };

    // handle add
    const handleAdd = async () => {
      if (
        userName.value &&
        userDesignation.value &&
        userEmail.value
      ) {

        // Benefits
        // Start Uploading
        isSubmitting.value = true;

        // round up
        const newVal = {
          name: userName.value,
          slug: userName.value?.trim().split(' ')[0],
          designation: userDesignation.value,
          email: userEmail.value,
          department: userDepartment.value,
          staff_id: userStaffID.value,
          official_line: userOfficialLine.value,
        };

        if (userID.value && userStatus.value && userStatus.value !== "d") {
          // update User account
          const { res, err } = await putItem("authority/client/update/vanilla", userID.value, newVal);

          if (res.value) {
            // clear
            clearUser();
            // get all
            getUsers(res.value.data.id);
          } else {
            error.value = err.value;
            isSubmitting.value = false;
          }

        } else if (!userID.value) {

          // pass
          let newPass = Array(7).fill().map(() => String.fromCharCode(Math.floor(Math.random() * 26) + 97)).join('');

          // prime object
          newVal.level = userLevel.value;
          newVal.schemes = allSchemes.value.map(item => item.id); // use standard default
          newVal.modules = allModules.value.map(item => item.to); // use standard default
          newVal.client_id = store.state.user.client_id;
          newVal.type = "client";
          newVal.status = "p";
          newVal.password = newPass;

          // creat new User account
          const { res, err } = await postItem("authority/client/create", newVal);

          if (res.value) {
            // filter old passes out
            newPasses.value = newPasses.value.filter(x => x.id !== res.value.data.id);
            // keep new password
            newPasses.value.push({ id: res.value.data.id, password: newPass });
            // clear
            clearUser();
            // get all
            getUsers(res.value.data.id);
          } else {
            error.value = err.value;
          }

        }

        isSubmitting.value = false;

      } else {
        error.value = true;
      }
    };

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // output results (plans)
    const users = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    return {
      isReady,
      isLoading,
      isSubmitting,
      error,
      handleStatus,
      handleReset,
      handleEdit,
      handleAdd,
      handleBack,
      handleSwitch,
      handleUpdateComplete,
      handleActive,
      home,
      currTab,
      tabs,
      userID,
      userName,
      userDesignation,
      userEmail,
      userDepartment,
      userStaffID,
      userOfficialLine,
      userLevel,
      userSchemes,
      userModules,
      next,
      allModules,
      allSchemes,
      newPasses,
      newUser,
      users,
    };
  },
};
</script>

<style>
.top-card {
  background-color: #163f53;
}

.top-card-light {
  background-color: #254657;
}

.top-card-dark {
  background-color: #163f53;
}

.progress {
  margin-top: -10px;
}

.custom-nav {
  height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}

.grey-bg-custom {
  background-color: #f2f2f2;
}

.hover-text {
  cursor: pointer;
}

.clickable {
  cursor: pointer;
}
</style>